export * from './instance.read.service';
export * from './instance.write.service';
export * from './instanceType.service';
export * from './templates';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/instance/index.ts